function HomePage({
  badge = "The Premier Team Chess Platform",
  titleLead = "Build a Team.",
  titleAccent = "Compete Globally. Win Glory.",
  description = "",
  stats = [],
  primaryActionLabel = "Start Competing",
  secondaryActionLabel = "Browse Leagues",
  onPrimaryAction,
  onSecondaryAction,
}) {
  return (
    <section className="appRoutePage homeRoutePage landingRoutePage">
      <div className="landingRouteHero">
        <div className="landingRouteBackdrop" aria-hidden="true">
          <div className="landingRouteGlow landingRouteGlowBlue" />
          <div className="landingRouteGlow landingRouteGlowGold" />
          <div className="landingChessGrid" />
        </div>

        <div className="landingRouteContent">
          <div className="landingHeroBadge">
            <span aria-hidden="true">{"\u2655"}</span>
            <span>{badge}</span>
          </div>

          <div className="landingHeroCopy">
            <h1 className="landingHeroTitle">
              <span>{titleLead}</span>
              <span className="isAccent">{titleAccent}</span>
            </h1>
            {description ? <p className="landingHeroDescription">{description}</p> : null}
          </div>

          <div className="landingHeroActions">
            <button type="button" className="primaryButton landingPrimaryButton" onClick={onPrimaryAction}>
              {primaryActionLabel}
              <span className="landingActionArrow" aria-hidden="true">{"\u2192"}</span>
            </button>
            <button type="button" className="secondaryButton landingSecondaryButton" onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </button>
          </div>

          {stats.length > 0 ? (
            <div className="landingStatsBar">
              {stats.map((stat, index) => (
                <div key={stat.label} className="landingStatItem">
                  <strong className={`landingStatValue is-${stat.tone || "blue"}`}>{stat.value}</strong>
                  <span className="landingStatLabel">{stat.label}</span>
                  {index < stats.length - 1 ? <span className="landingStatDivider" aria-hidden="true" /> : null}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default HomePage;
